import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import TBody from '@/components/Base/TBody';

import { TableComponent, TableTitle } from './Table.styles';

export function Table({ id, items }) {
  const { formatMessage } = useIntl();

  return (
    <TableComponent id={id} className="customTable">
      {!!id && (
        <TableTitle>
          {formatMessage({ id: `details.table.title.${id}` })}
        </TableTitle>
      )}

      <TBody items={items} />
    </TableComponent>
  );
}

Table.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      hint: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    })
  ).isRequired,
  id: PropTypes.string.isRequired,
};

export default memo(Table);
